import { render, staticRenderFns } from "./CompanyTianyancha.vue?vue&type=template&id=923bb3e8&scoped=true&"
import script from "./CompanyTianyancha.vue?vue&type=script&lang=js&"
export * from "./CompanyTianyancha.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTianyancha.vue?vue&type=style&index=0&id=923bb3e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923bb3e8",
  null
  
)

export default component.exports